// 營業時間單一星期列的「起始 – 結束」時間輸入框，5 個 Mutate*ServiceForm 共用。
import React from 'react';
import { TextInput } from '@mantine/core';

const timeInputStyle = { width: 60, fontSize: 12, fontWeight: 400 };
const timeInputStyles = {
  input: { fontSize: 12, textAlign: 'center' as const },
};

interface WeekdayTimeRangeInputsProps {
  startValue: string;
  endValue: string;
  onStartChange: (value: string) => void;
  onEndChange: (value: string) => void;
  onCommitStart: (value: string) => void;
  onCommitEnd: (value: string) => void;
  startError?: boolean;
  endError?: boolean;
}

const WeekdayTimeRangeInputs: React.FC<WeekdayTimeRangeInputsProps> = ({
  startValue,
  endValue,
  onStartChange,
  onEndChange,
  onCommitStart,
  onCommitEnd,
  startError,
  endError,
}) => (
  <>
    <TextInput
      value={startValue}
      onChange={(e) => onStartChange(e.target.value)}
      onBlur={(e) => onCommitStart(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onCommitStart(e.currentTarget.value);
        }
      }}
      error={!!startError}
      placeholder="HHMM"
      size="xs"
      style={timeInputStyle}
      styles={timeInputStyles}
    />
    <div> - </div>
    <TextInput
      value={endValue}
      onChange={(e) => onEndChange(e.target.value)}
      onBlur={(e) => onCommitEnd(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onCommitEnd(e.currentTarget.value);
        }
      }}
      error={!!endError}
      placeholder="HHMM"
      size="xs"
      style={timeInputStyle}
      styles={timeInputStyles}
    />
  </>
);

export default WeekdayTimeRangeInputs;
